var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ResultStatusObj } from "@payair/srci-logic-sdk/models/ResultStatus";
import { decodeJwt } from "jose";
import { DcfSdkEnumsObj } from "../enums/DcfSdkEnum";
import { SrciScreenEnumsObj } from "../enums/internal/SrciScreenEnum";
import { SrciEventTypeEnumsObj } from "../enums/SrciEventTypeEnum";
import { defaultPaymentSheetContainerId, srciUiComponentId } from "./ui/SrciUi";
import srciLogicSdk from "@payair/srci-logic-sdk";
import { getInitScreen, initSrciImpl, updateScreen } from "./SrciSdk";
import { ErrorCodesObj, SomethingWentWrongErrorCodesObj } from "../helpers/ErrorMapper";
import { DEFAULT_COMPLIANCE_SETTINGS, getDcfSuppressedDpaTransactionOptions, isDcfSuppressedCheck, } from "../helpers/DcfSuppressed";
import { projectLegacyCheckoutConsumer } from "./consumer/LegacyConsumerProjection";
import { buildRememberMeComplianceSettings } from "./checkout/RememberMeComplianceSettings";
import { MerchantRecognitionCoordinator } from "./recognition/MerchantRecognitionCoordinator";
import { unlockPaymentSheetHostScroll } from "./PaymentSheetHostScrollLock";
import { adaptConsumerCheckoutErrors } from "./consumer/ConsumerCheckoutErrorAdapter";
import { buildBackendErrorTelemetry, buildDcfActionTelemetry, buildDcfTelemetry, buildProfileSuccessTelemetry, buildReasonTelemetry, buildRequired3dsTelemetry, buildUnbindErrorTelemetry, buildUnexpectedExceptionTelemetry, } from "./telemetry/SrciTelemetry";
import { SrciIdentityLifecycle } from "./telemetry/SrciIdentityLifecycle";
/** @internal */ var DEFAULT_DPA_LOCALE = "en_GB";
/** @internal */
var SrciLogic = /** @class */ (function () {
    function SrciLogic(srciDcfFrame, languageHandler, eventReporter, allowedCardCountries, allowedCardTypes, merchantRecognition) {
        var _this = this;
        this.getMappedAddCardReason = function (checkout, cardBrand) {
            var _a, _b;
            try {
                if (!checkout || typeof checkout !== "object")
                    return undefined;
                var result = checkout;
                var mappedReason = (_b = adaptConsumerCheckoutErrors([
                    { reason: result.reason, dcf: (_a = result.sdk) !== null && _a !== void 0 ? _a : cardBrand },
                ]).generalErrors[0]) === null || _b === void 0 ? void 0 : _b.reason;
                return typeof mappedReason === "string" ? mappedReason : undefined;
            }
            catch (_error) {
                return undefined;
            }
        };
        this.getDpaTransactionOptions = function (srciInitParams, srciDcfParams) {
            if (srciDcfParams && srciDcfParams.dpaTransactionOptions) {
                return srciDcfParams.dpaTransactionOptions;
            }
            if (!srciInitParams) {
                throw new Error("SrciInitParams must be defined when srciDcfParams.dpaTransactionOptions is not");
            }
            var dpaTransactionOptions = {
                dpaLocale: DEFAULT_DPA_LOCALE,
                transactionAmount: {
                    transactionAmount: parseFloat(srciInitParams.totalAmount),
                    transactionCurrencyCode: srciInitParams.currencyCode,
                },
            };
            return dpaTransactionOptions;
        };
        this.init = function (srciInitParams, srciDcfParams, dcfSdkEnum) { return __awaiter(_this, void 0, void 0, function () {
            var dpaTransactionOptions, srciIdentificator, srciLogicSdkInitParams;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dpaTransactionOptions = this.getDpaTransactionOptions(srciInitParams, srciDcfParams);
                        srciIdentificator = srciDcfParams.srciIdentificator;
                        if (!(srciIdentificator && srciIdentificator.srcInitiatorId && srciIdentificator.srciDpaId)) return [3 /*break*/, 2];
                        srciLogicSdkInitParams = {
                            srcInitiatorId: srciIdentificator.srcInitiatorId,
                            srciDpaId: srciIdentificator.srciDpaId,
                            srciTransactionId: srciInitParams.transactionId,
                            dpaTransactionOptions: dpaTransactionOptions,
                            dpaData: srciDcfParams.srciDpaData,
                            pspName: srciInitParams.pspName,
                            environment: srciInitParams.environment,
                        };
                        return [4 /*yield*/, srciLogicSdk.init(srciLogicSdkInitParams, dcfSdkEnum)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [2 /*return*/, false];
                }
            });
        }); };
        this.processPayment = function (commonState, mastercardState, visaState, srciActionCode, cardBrand, encryptedCard, srcDigitalCardId) { return __awaiter(_this, void 0, void 0, function () {
            var errorReason;
            var _a;
            return __generator(this, function (_b) {
                if (srciActionCode === "NEW_USER") {
                    errorReason = ErrorCodesObj.MERCHANT_DATA_INVALID;
                    return [2 /*return*/, [this.getError(SrciEventTypeEnumsObj.PAYMENT_COMPLETION_ERROR, errorReason, cardBrand)]];
                }
                return [2 /*return*/, this.processPaymentRequest({
                        commonState: commonState,
                        mastercardState: mastercardState,
                        visaState: visaState,
                        srciActionCode: srciActionCode,
                        cardBrand: cardBrand,
                        encryptedCard: encryptedCard,
                        srcDigitalCardId: srcDigitalCardId,
                        consumer: projectLegacyCheckoutConsumer((_a = commonState === null || commonState === void 0 ? void 0 : commonState.initParams) === null || _a === void 0 ? void 0 : _a.srciConsumer),
                        rememberMe: commonState === null || commonState === void 0 ? void 0 : commonState.rememberMeConsent,
                    })];
            });
        }); };
        this.processNewUserPayment = function (commonState, mastercardState, visaState, payment) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.processPaymentRequest({
                        commonState: commonState,
                        mastercardState: mastercardState,
                        visaState: visaState,
                        srciActionCode: "NEW_USER",
                        cardBrand: payment.cardBrand,
                        encryptedCard: payment.encryptedCard,
                        consumer: payment.consumer,
                        rememberMe: payment.rememberMe,
                    })];
            });
        }); };
        this.getRecognizedAddCardIdToken = function (cardBrand, mastercardState, visaState) {
            var targetTokens = cardBrand === DcfSdkEnumsObj.MASTERCARD
                ? mastercardState.idTokens
                : cardBrand === DcfSdkEnumsObj.VISA
                    ? visaState.idTokens
                    : undefined;
            var fallbackTokens = cardBrand === DcfSdkEnumsObj.MASTERCARD
                ? visaState.idTokens
                : cardBrand === DcfSdkEnumsObj.VISA
                    ? mastercardState.idTokens
                    : undefined;
            var selectedTokens = (targetTokens === null || targetTokens === void 0 ? void 0 : targetTokens.length) ? targetTokens : fallbackTokens;
            var uniqueTokens = Array.from(new Set(selectedTokens || []));
            return uniqueTokens.length === 1 ? uniqueTokens[0] : undefined;
        };
        this.processRecognizedAddCardPayment = function (commonState, mastercardState, visaState, payment) { return __awaiter(_this, void 0, void 0, function () {
            var telemetryContext;
            return __generator(this, function (_a) {
                telemetryContext = {
                    operation: "ADD_CARD",
                    network: payment.cardBrand,
                };
                return [2 /*return*/, this.processPaymentRequest({
                        commonState: commonState,
                        mastercardState: mastercardState,
                        visaState: visaState,
                        srciActionCode: "",
                        cardBrand: payment.cardBrand,
                        encryptedCard: payment.encryptedCard,
                        consumer: payment.consumer,
                        idToken: payment.idToken,
                        rememberMe: commonState.rememberMeConsent,
                        telemetryContext: telemetryContext,
                    })];
            });
        }); };
        this.processPaymentRequest = function (_a) {
            var commonState = _a.commonState, mastercardState = _a.mastercardState, visaState = _a.visaState, srciActionCode = _a.srciActionCode, cardBrand = _a.cardBrand, encryptedCard = _a.encryptedCard, srcDigitalCardId = _a.srcDigitalCardId, consumer = _a.consumer, idToken = _a.idToken, rememberMe = _a.rememberMe, telemetryContext = _a.telemetryContext;
            return __awaiter(_this, void 0, void 0, function () {
                var errorReason, dcfParams, dpaTransactionOptions, srcDpaId, errorReason, errorReason, offlineTelemetryContext, windowRef, isDcfSuppressed, checkoutParams, checkout, mappedReason, errorMessage, checkoutValue, resetsIdentity, error_1;
                var _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            if (!commonState || !commonState.initParams) {
                                errorReason = "SRC SDK is not initialized";
                                return [2 /*return*/, [
                                        this.getError(SrciEventTypeEnumsObj.SDK_INITIALIZE_ERROR, errorReason, cardBrand, buildReasonTelemetry(errorReason, __assign(__assign({}, telemetryContext), { network: cardBrand }))),
                                    ]];
                            }
                            dcfParams = commonState.initParams.merchantId.get(cardBrand);
                            dpaTransactionOptions = this.getDpaTransactionOptions(commonState.initParams, dcfParams);
                            srcDpaId = dcfParams === null || dcfParams === void 0 ? void 0 : dcfParams.srciIdentificator.srciDpaId;
                            if (!srcDpaId) {
                                errorReason = "DcfParams or CardBrand not defined";
                                return [2 /*return*/, [
                                        this.getError(SrciEventTypeEnumsObj.SDK_INITIALIZE_ERROR, errorReason, cardBrand, buildReasonTelemetry(errorReason, __assign(__assign({}, telemetryContext), { network: cardBrand }))),
                                    ]];
                            }
                            if (typeof navigator !== "undefined" && navigator.onLine === false) {
                                errorReason = ErrorCodesObj.NO_INTERNET_CONNECTION;
                                offlineTelemetryContext = buildReasonTelemetry(errorReason, __assign(__assign({}, telemetryContext), { stage: "DCF_CHECKOUT", network: cardBrand }));
                                return [2 /*return*/, [
                                        this.getError(SrciEventTypeEnumsObj.PAYMENT_COMPLETION_ERROR, errorReason, cardBrand, offlineTelemetryContext),
                                    ]];
                            }
                            _d.label = 1;
                        case 1:
                            _d.trys.push([1, 6, , 7]);
                            this.eventReporter.sendEvent(SrciEventTypeEnumsObj.PAYMENT_COMPLETION_STARTED, telemetryContext);
                            windowRef = null;
                            if (commonState.isDcfFlowPopUp === false) {
                                windowRef = this.srciDcfFrame.getDcfWindowRef(srciUiComponentId);
                            }
                            isDcfSuppressed = isDcfSuppressedCheck(cardBrand);
                            checkoutParams = __assign(__assign({ encryptedCard: encryptedCard, srcDigitalCardId: srcDigitalCardId, dpaTransactionOptions: isDcfSuppressed === true
                                    ? getDcfSuppressedDpaTransactionOptions(dpaTransactionOptions)
                                    : dpaTransactionOptions, srciActionCode: srciActionCode, consumer: consumer }, (idToken ? { idToken: idToken } : {})), { complianceSettings: buildRememberMeComplianceSettings({
                                    rememberMe: rememberMe === true,
                                    dpaUri: (_b = dcfParams === null || dcfParams === void 0 ? void 0 : dcfParams.srciDpaData) === null || _b === void 0 ? void 0 : _b.dpaUri,
                                    existingComplianceSettings: isDcfSuppressed === true ? DEFAULT_COMPLIANCE_SETTINGS : undefined,
                                }), windowRef: windowRef });
                            if (cardBrand === DcfSdkEnumsObj.VISA) {
                                checkoutParams.srciTransactionId = commonState.initParams.transactionId;
                            }
                            return [4 /*yield*/, srciLogicSdk.checkout(checkoutParams, cardBrand)];
                        case 2:
                            checkout = (_d.sent())[0];
                            if (checkout.status !== ResultStatusObj.FULFILLED) {
                                this.srciDcfFrame.hideDcfIframe(commonState.isDcfFlowPopUp);
                                mappedReason = telemetryContext ? this.getMappedAddCardReason(checkout, cardBrand) : undefined;
                                this.eventReporter.sendEvent(SrciEventTypeEnumsObj.PAYMENT_COMPLETION_ERROR, buildDcfTelemetry(checkout, __assign(__assign({}, telemetryContext), { stage: "DCF_CHECKOUT", network: cardBrand }), typeof mappedReason === "string" ? mappedReason : undefined));
                                return [2 /*return*/, [{ reason: checkout.reason, dcf: (_c = checkout.sdk) !== null && _c !== void 0 ? _c : cardBrand }]];
                            }
                            if (!checkout.value) {
                                errorMessage = "Checkout response is undefined";
                                this.srciDcfFrame.hideDcfIframe(commonState.isDcfFlowPopUp);
                                return [2 /*return*/, [
                                        this.getError(SrciEventTypeEnumsObj.PAYMENT_COMPLETION_ERROR, errorMessage, cardBrand, buildReasonTelemetry("INVALID_RESPONSE", __assign(__assign({}, telemetryContext), { stage: "DCF_CHECKOUT", network: cardBrand }))),
                                    ]];
                            }
                            checkoutValue = checkout.value;
                            resetsIdentity = checkoutValue.unbindAppInstance === true || checkoutValue.dcfActionCode === "SWITCH_CONSUMER";
                            if (checkoutValue.idToken) {
                                this.addIdToken(mastercardState, visaState, checkoutValue.idToken, cardBrand);
                            }
                            if (!resetsIdentity) {
                                this.merchantRecognition.persistRecognitionToken(checkoutValue.recognitionToken, cardBrand, rememberMe === true);
                            }
                            if (!(checkoutValue.unbindAppInstance === true)) return [3 /*break*/, 4];
                            return [4 /*yield*/, this.unbindAppInstance(commonState, mastercardState, visaState)];
                        case 3:
                            _d.sent();
                            _d.label = 4;
                        case 4: return [4 /*yield*/, this.handleCheckoutDcfActionCode(commonState, mastercardState, visaState, checkoutValue, srcDpaId, cardBrand, telemetryContext)];
                        case 5: return [2 /*return*/, _d.sent()];
                        case 6:
                            error_1 = _d.sent();
                            this.handlePaymentError(commonState, SrciEventTypeEnumsObj.PAYMENT_COMPLETION_ERROR, buildUnexpectedExceptionTelemetry(__assign(__assign({}, telemetryContext), { stage: "DCF_CHECKOUT", network: cardBrand }), error_1));
                            return [2 /*return*/, [{ reason: error_1.message }]];
                        case 7: return [2 /*return*/];
                    }
                });
            });
        };
        this.addIdToken = function (mastercardState, visaState, idToken, cardBrand) {
            switch (cardBrand) {
                case DcfSdkEnumsObj.MASTERCARD:
                    mastercardState.idTokens = [idToken];
                    break;
                case DcfSdkEnumsObj.VISA:
                    visaState.idTokens = [idToken];
                    break;
                default:
                    break;
            }
        };
        this.getCheckoutResponse = function (checkoutValue, cardBrand) {
            switch (cardBrand) {
                case DcfSdkEnumsObj.MASTERCARD: {
                    var checkoutResponse = checkoutValue.checkoutResponse;
                    if (checkoutResponse) {
                        return checkoutResponse;
                    }
                    break;
                }
                case DcfSdkEnumsObj.VISA: {
                    var checkoutJwsResponse = checkoutValue.checkoutResponse;
                    if (checkoutJwsResponse && typeof checkoutJwsResponse === "string") {
                        return decodeJwt(checkoutJwsResponse);
                    }
                    break;
                }
            }
            return null;
        };
        this.getError = function (eventType, errorReason, dcf, additionalInfo) {
            if (additionalInfo === void 0) { additionalInfo = buildReasonTelemetry(errorReason, { network: dcf }); }
            _this.eventReporter.sendEvent(eventType, additionalInfo);
            return { reason: errorReason, dcf: dcf };
        };
        this.handleRecoverableCheckoutActionError = function (_a) {
            var commonState = _a.commonState, cardBrand = _a.cardBrand, checkoutValue = _a.checkoutValue, telemetryContext = _a.telemetryContext, _b = _a.eventType, eventType = _b === void 0 ? SrciEventTypeEnumsObj.PAYMENT_COMPLETION_NOK : _b;
            _this.srciDcfFrame.hideDcfIframe(commonState.isDcfFlowPopUp);
            _this.eventReporter.sendEvent(eventType, buildDcfActionTelemetry(checkoutValue, cardBrand, telemetryContext || {}));
            return [{ reason: SomethingWentWrongErrorCodesObj.SERVER_ERROR, dcf: cardBrand }];
        };
        this.handleCheckoutDcfActionCode = function (commonState, mastercardState, visaState, checkoutValue, srcDpaId, cardBrand, telemetryContext) { return __awaiter(_this, void 0, void 0, function () {
            var _a, checkoutResponse, mastercardProfiles, visaProfiles, initScreen, isFetchProfilesEnabled;
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!commonState.initParams || !srcDpaId) {
                            this.eventReporter.sendEvent(SrciEventTypeEnumsObj.SDK_INITIALIZE_ERROR, buildReasonTelemetry("SDK_NOT_INITIALIZED", __assign(__assign({}, telemetryContext), { network: cardBrand })));
                            return [2 /*return*/, []];
                        }
                        _a = checkoutValue.dcfActionCode;
                        switch (_a) {
                            case "COMPLETE": return [3 /*break*/, 1];
                            case "CHANGE_CARD": return [3 /*break*/, 4];
                            case "ADD_CARD": return [3 /*break*/, 9];
                            case "SWITCH_CONSUMER": return [3 /*break*/, 11];
                            case "CANCEL": return [3 /*break*/, 13];
                            case "ERROR": return [3 /*break*/, 15];
                        }
                        return [3 /*break*/, 16];
                    case 1:
                        checkoutResponse = void 0;
                        try {
                            checkoutResponse = this.getCheckoutResponse(checkoutValue, cardBrand);
                        }
                        catch (_e) {
                            return [2 /*return*/, this.handleRecoverableCheckoutActionError({
                                    commonState: commonState,
                                    cardBrand: cardBrand,
                                    checkoutValue: checkoutValue,
                                    telemetryContext: telemetryContext,
                                    eventType: SrciEventTypeEnumsObj.PAYMENT_COMPLETION_ERROR,
                                })];
                        }
                        if (!checkoutResponse) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.handleCheckoutComplete(commonState, checkoutResponse, srcDpaId, cardBrand, telemetryContext)];
                    case 2:
                        _d.sent();
                        return [2 /*return*/, []];
                    case 3: return [2 /*return*/, this.handleRecoverableCheckoutActionError({
                            commonState: commonState,
                            cardBrand: cardBrand,
                            checkoutValue: checkoutValue,
                            telemetryContext: telemetryContext,
                        })];
                    case 4:
                        mastercardProfiles = (_b = mastercardState.getProfileResponse) === null || _b === void 0 ? void 0 : _b.profiles;
                        visaProfiles = (_c = visaState.getProfileResponse) === null || _c === void 0 ? void 0 : _c.profiles;
                        if (!(mastercardProfiles || visaProfiles)) return [3 /*break*/, 6];
                        return [4 /*yield*/, updateScreen(SrciScreenEnumsObj.CARD_LIST_SCREEN, true)];
                    case 5:
                        _d.sent();
                        return [3 /*break*/, 8];
                    case 6: return [4 /*yield*/, updateScreen(SrciScreenEnumsObj.NEW_USER_SCREEN)];
                    case 7:
                        _d.sent();
                        _d.label = 8;
                    case 8: return [3 /*break*/, 17];
                    case 9: return [4 /*yield*/, updateScreen(SrciScreenEnumsObj.ADD_CARD_SCREEN)];
                    case 10:
                        _d.sent();
                        return [3 /*break*/, 17];
                    case 11:
                        this.resetConsumerIdentity(commonState, mastercardState, visaState);
                        return [4 /*yield*/, updateScreen(SrciScreenEnumsObj.NEW_USER_SCREEN)];
                    case 12:
                        _d.sent();
                        return [3 /*break*/, 17];
                    case 13:
                        initScreen = getInitScreen(false);
                        isFetchProfilesEnabled = undefined;
                        if (initScreen === SrciScreenEnumsObj.CARD_LIST_SCREEN) {
                            isFetchProfilesEnabled = true;
                        }
                        return [4 /*yield*/, updateScreen(initScreen, isFetchProfilesEnabled)];
                    case 14:
                        _d.sent();
                        return [3 /*break*/, 17];
                    case 15:
                        {
                            return [2 /*return*/, this.handleRecoverableCheckoutActionError({
                                    commonState: commonState,
                                    cardBrand: cardBrand,
                                    checkoutValue: checkoutValue,
                                    telemetryContext: telemetryContext,
                                    eventType: SrciEventTypeEnumsObj.PAYMENT_COMPLETION_ERROR,
                                })];
                        }
                        _d.label = 16;
                    case 16:
                        {
                            return [2 /*return*/, this.handleRecoverableCheckoutActionError({
                                    commonState: commonState,
                                    cardBrand: cardBrand,
                                    checkoutValue: checkoutValue,
                                    telemetryContext: telemetryContext,
                                })];
                        }
                        _d.label = 17;
                    case 17:
                        this.srciDcfFrame.hideDcfIframe(commonState.isDcfFlowPopUp);
                        this.eventReporter.sendEvent(SrciEventTypeEnumsObj.PAYMENT_COMPLETION_NOK, buildDcfActionTelemetry(checkoutValue, cardBrand, telemetryContext || {}));
                        return [2 /*return*/, []];
                }
            });
        }); };
        this.clearDcfState = function (mastercardState, visaState) {
            mastercardState.getProfileResponse = undefined;
            visaState.getProfileResponse = undefined;
        };
        this.resetConsumerIdentity = function (commonState, mastercardState, visaState) {
            commonState.isConsumerPresent = false;
            commonState.defaultDcfSdk = undefined;
            commonState.identityValidationChannels = undefined;
            commonState.otpChannelsData = undefined;
            commonState.selectedOtpChannel = undefined;
            commonState.pendingOtpSendOperation = undefined;
            commonState.rememberMeConsent = false;
            commonState.profileErrors = undefined;
            commonState.addCardForNoCardsCase = false;
            mastercardState.idTokens = undefined;
            visaState.idTokens = undefined;
            _this.clearDcfState(mastercardState, visaState);
            _this.clearMerchantRecognitionTokens();
        };
        this.clearMerchantRecognitionTokens = function () {
            _this.merchantRecognition.clearAll();
        };
        this.handlePaymentError = function (commonState, event, additionalInfo) {
            _this.srciDcfFrame.hideDcfIframe(commonState.isDcfFlowPopUp);
            _this.eventReporter.sendEvent(event, additionalInfo);
            _this.closePaymentSheet(commonState, SrciEventTypeEnumsObj.PAYMENT_SHEET_CLOSED_PURCHASE_DONE);
        };
        this.handleCheckoutComplete = function (commonState, checkoutResponse, srcDpaId, cardBrand, telemetryContext) { return __awaiter(_this, void 0, void 0, function () {
            var srcTransactionId, srciCheckoutRequest, isCardCountryCodeAllowed, isCardTypeAllowed, checkoutTransactionResponse, xRequestId, checkoutTransactionErrors, srciCheckoutReponse, is3dsRequired, error_2;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        srcTransactionId = checkoutResponse.srciTransactionId
                            ? checkoutResponse.srciTransactionId
                            : (_a = commonState.initParams) === null || _a === void 0 ? void 0 : _a.transactionId;
                        if (!srcTransactionId) {
                            throw new Error("srcTransactionId is undefined");
                        }
                        srciCheckoutRequest = {
                            srcCorrelationId: checkoutResponse.srcCorrelationId,
                            srcDigitalCardId: checkoutResponse.maskedCard.srcDigitalCardId != null ? checkoutResponse.maskedCard.srcDigitalCardId : "",
                            srcDpaId: srcDpaId,
                            srcTransactionId: srcTransactionId,
                            cardNetwork: cardBrand,
                        };
                        if (this.allowedCardCountries) {
                            isCardCountryCodeAllowed = ((_b = checkoutResponse.maskedCard.maskedBillingAddress) === null || _b === void 0 ? void 0 : _b.countryCode) &&
                                this.allowedCardCountries.includes(checkoutResponse.maskedCard.maskedBillingAddress.countryCode);
                            if (!isCardCountryCodeAllowed) {
                                this.handlePaymentError(commonState, SrciEventTypeEnumsObj.PAYMENT_COMPLETION_NOK, buildReasonTelemetry(SrciEventTypeEnumsObj.CARD_COUNTRY_NOT_ALLOWED, __assign(__assign({}, telemetryContext), { stage: "LOCAL_VALIDATION", network: cardBrand })));
                                return [2 /*return*/];
                            }
                        }
                        if (this.allowedCardTypes) {
                            isCardTypeAllowed = checkoutResponse.maskedCard.paymentCardType &&
                                this.allowedCardTypes.includes(checkoutResponse.maskedCard.paymentCardType);
                            if (!isCardTypeAllowed) {
                                this.handlePaymentError(commonState, SrciEventTypeEnumsObj.PAYMENT_COMPLETION_NOK, buildReasonTelemetry(SrciEventTypeEnumsObj.CARD_TYPE_NOT_ALLOWED, __assign(__assign({}, telemetryContext), { stage: "LOCAL_VALIDATION", network: cardBrand })));
                                return [2 /*return*/];
                            }
                        }
                        return [4 /*yield*/, srciLogicSdk.checkoutTransaction(srciCheckoutRequest)];
                    case 1:
                        checkoutTransactionResponse = _c.sent();
                        xRequestId = checkoutTransactionResponse.xRequestId;
                        this.srciDcfFrame.hideDcfIframe(commonState.isDcfFlowPopUp);
                        checkoutTransactionErrors = checkoutTransactionResponse === null || checkoutTransactionResponse === void 0 ? void 0 : checkoutTransactionResponse.errors;
                        if (checkoutTransactionErrors) {
                            this.eventReporter.sendEvent(SrciEventTypeEnumsObj.PAYMENT_COMPLETION_NOK, buildBackendErrorTelemetry({
                                errors: checkoutTransactionErrors.errors,
                                httpStatus: checkoutTransactionResponse.httpStatus,
                                srcCorrelationId: checkoutResponse.srcCorrelationId,
                                context: __assign(__assign({}, telemetryContext), { network: cardBrand }),
                            }), xRequestId ? xRequestId : undefined);
                            this.closePaymentSheet(commonState, SrciEventTypeEnumsObj.PAYMENT_SHEET_CLOSED_PURCHASE_DONE);
                            return [2 /*return*/];
                        }
                        srciCheckoutReponse = checkoutTransactionResponse === null || checkoutTransactionResponse === void 0 ? void 0 : checkoutTransactionResponse.srciCheckoutResponse;
                        is3dsRequired = (srciCheckoutReponse === null || srciCheckoutReponse === void 0 ? void 0 : srciCheckoutReponse.status) === "REQUIRED_3DS";
                        if (is3dsRequired) {
                            this.eventReporter.sendEvent(SrciEventTypeEnumsObj.PAYMENT_COMPLETION_REQUIRED_3DS, buildRequired3dsTelemetry({
                                response: srciCheckoutReponse,
                                srcCorrelationId: checkoutResponse.srcCorrelationId,
                                context: __assign(__assign({}, telemetryContext), { network: cardBrand }),
                            }), xRequestId ? xRequestId : undefined);
                            this.closePaymentSheet(commonState, SrciEventTypeEnumsObj.PAYMENT_SHEET_CLOSED_PURCHASE_DONE);
                            return [2 /*return*/];
                        }
                        this.eventReporter.sendEvent(SrciEventTypeEnumsObj.PAYMENT_COMPLETION_OK, telemetryContext, xRequestId ? xRequestId : undefined);
                        this.closePaymentSheet(commonState, SrciEventTypeEnumsObj.PAYMENT_SHEET_CLOSED_PURCHASE_DONE);
                        return [2 /*return*/];
                    case 2:
                        error_2 = _c.sent();
                        this.handlePaymentError(commonState, SrciEventTypeEnumsObj.PAYMENT_COMPLETION_NOK, buildUnexpectedExceptionTelemetry(__assign(__assign({}, telemetryContext), { stage: "CHECKOUT_TRANSACTION", network: cardBrand }), error_2));
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.getProfilesAndUpdateState = function (commonState, mastercardState, visaState) { return __awaiter(_this, void 0, void 0, function () {
            var supportedNetworks, getSrcProfilesResult, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        supportedNetworks = [];
                        if (mastercardState.isSupported)
                            supportedNetworks.push(DcfSdkEnumsObj.MASTERCARD);
                        if (visaState.isSupported)
                            supportedNetworks.push(DcfSdkEnumsObj.VISA);
                        return [4 /*yield*/, this.getSrcProfiles(commonState, mastercardState.idTokens, visaState.idTokens, supportedNetworks)];
                    case 1:
                        getSrcProfilesResult = _a.sent();
                        if (this.allowedCardCountries || this.allowedCardTypes) {
                            this.filterGetSrcProfiles(getSrcProfilesResult, this.allowedCardCountries, this.allowedCardTypes);
                        }
                        mastercardState.getProfileResponse = getSrcProfilesResult === null || getSrcProfilesResult === void 0 ? void 0 : getSrcProfilesResult.mastercardGetProfileResponse;
                        visaState.getProfileResponse = getSrcProfilesResult === null || getSrcProfilesResult === void 0 ? void 0 : getSrcProfilesResult.visaGetProfileResponse;
                        return [2 /*return*/, getSrcProfilesResult];
                    case 2:
                        error_3 = _a.sent();
                        this.eventReporter.sendEvent(SrciEventTypeEnumsObj.GET_SRCI_PROFILE_ERROR, buildReasonTelemetry(SomethingWentWrongErrorCodesObj.SERVER_ERROR));
                        throw error_3;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        this.filterGetSrcProfiles = function (getSrcProfiles, allowedCardCountries, allowedCardTypes) {
            var _a;
            if (getSrcProfiles &&
                getSrcProfiles.mastercardGetProfileResponse &&
                (getSrcProfiles === null || getSrcProfiles === void 0 ? void 0 : getSrcProfiles.mastercardGetProfileResponse.profiles)) {
                var mastercardSrcProfiles = getSrcProfiles.mastercardGetProfileResponse.profiles;
                var filteredMastercardProfiles = _this.filterMaskedCards(mastercardSrcProfiles, allowedCardCountries, allowedCardTypes);
                getSrcProfiles.mastercardGetProfileResponse.profiles = filteredMastercardProfiles;
            }
            if (getSrcProfiles && getSrcProfiles.visaGetProfileResponse && (getSrcProfiles === null || getSrcProfiles === void 0 ? void 0 : getSrcProfiles.visaGetProfileResponse.profiles)) {
                var visaSrcProfiles = (_a = getSrcProfiles === null || getSrcProfiles === void 0 ? void 0 : getSrcProfiles.visaGetProfileResponse) === null || _a === void 0 ? void 0 : _a.profiles;
                var filteredVisaProfiles = _this.filterMaskedCards(visaSrcProfiles, allowedCardCountries, allowedCardTypes);
                getSrcProfiles.visaGetProfileResponse.profiles = filteredVisaProfiles;
            }
        };
        this.filterMaskedCards = function (srcProfiles, allowedCardCountries, allowedCardTypes) {
            var srcProfilesCopy = JSON.parse(JSON.stringify(srcProfiles));
            var filteredSrcProfiles = srcProfilesCopy.map(function (srcProfile) {
                var filteredMaskedCards = srcProfile.maskedCards.filter(function (maskedCard) {
                    // card country filter
                    if (allowedCardCountries) {
                        if (!maskedCard.maskedBillingAddress || !maskedCard.maskedBillingAddress.countryCode) {
                            return false;
                        }
                        var isAllowedCardCountry = allowedCardCountries.includes(maskedCard.maskedBillingAddress.countryCode);
                        if (isAllowedCardCountry === false) {
                            return false;
                        }
                        // if true, moving to the next filter
                    }
                    // card type filter
                    if (allowedCardTypes) {
                        if (!maskedCard.paymentCardType) {
                            return false;
                        }
                        var isCardTypeAllowed = allowedCardTypes.includes(maskedCard.paymentCardType);
                        if (isCardTypeAllowed === false) {
                            return false;
                        }
                        // if true, moving to the next filter
                    }
                    // return true if none of the filters returns false
                    return true;
                });
                srcProfile.maskedCards = filteredMaskedCards;
                return srcProfile;
            });
            return filteredSrcProfiles;
        };
        this.unbindAppInstance = function (commonState, mastercardState, visaState) { return __awaiter(_this, void 0, void 0, function () {
            var singleSupportedNetwork, unbindResponse, _a, rejectedResponses, errors, error_4;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.resetConsumerIdentity(commonState, mastercardState, visaState);
                        this.eventReporter.sendEvent(SrciEventTypeEnumsObj.UNBIND_STARTED);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 6, , 7]);
                        singleSupportedNetwork = mastercardState.isSupported && !visaState.isSupported
                            ? DcfSdkEnumsObj.MASTERCARD
                            : visaState.isSupported && !mastercardState.isSupported
                                ? DcfSdkEnumsObj.VISA
                                : undefined;
                        if (!singleSupportedNetwork) return [3 /*break*/, 3];
                        return [4 /*yield*/, srciLogicSdk.unbindAppInstance(undefined, singleSupportedNetwork)];
                    case 2:
                        _a = _b.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, srciLogicSdk.unbindAppInstance()];
                    case 4:
                        _a = _b.sent();
                        _b.label = 5;
                    case 5:
                        unbindResponse = _a;
                        rejectedResponses = unbindResponse.filter(function (response) { return response.status !== ResultStatusObj.FULFILLED; });
                        errors = rejectedResponses
                            .map(function (errorResponse) {
                            var errorModel = {
                                reason: SomethingWentWrongErrorCodesObj.SERVER_ERROR,
                                dcf: errorResponse.sdk,
                            };
                            return errorModel;
                        });
                        if (errors.length > 0) {
                            this.eventReporter.sendEvent(SrciEventTypeEnumsObj.UNBIND_ERROR, buildUnbindErrorTelemetry(rejectedResponses));
                        }
                        else {
                            this.eventReporter.sendEvent(SrciEventTypeEnumsObj.UNBIND_OK);
                        }
                        if (errors.length > 0) {
                            return [2 /*return*/, errors];
                        }
                        return [3 /*break*/, 7];
                    case 6:
                        error_4 = _b.sent();
                        this.eventReporter.sendEvent(SrciEventTypeEnumsObj.UNBIND_ERROR, buildUnexpectedExceptionTelemetry({}, error_4));
                        return [2 /*return*/, [{ reason: SomethingWentWrongErrorCodesObj.SERVER_ERROR }]];
                    case 7: return [2 /*return*/];
                }
            });
        }); };
        this.closePaymentSheet = function (commonState, srciEventTypeEnum) { return __awaiter(_this, void 0, void 0, function () {
            var paymentSheetContainer, srcButton;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        commonState.rememberMeConsent = false;
                        commonState.pendingOtpSendOperation = undefined;
                        window.removeEventListener("resize", this.srciDcfFrame.onResizeEvent);
                        this.srciDcfFrame.deactivateDcfPresentation();
                        if (!commonState.paymentSheetContainerId)
                            return [2 /*return*/];
                        if (commonState.paymentSheetContainerId === defaultPaymentSheetContainerId) {
                            unlockPaymentSheetHostScroll();
                        }
                        paymentSheetContainer = document.getElementById(commonState.paymentSheetContainerId);
                        if (paymentSheetContainer) {
                            commonState.paymentSheetContainerId !== defaultPaymentSheetContainerId
                                ? paymentSheetContainer.replaceChildren()
                                : paymentSheetContainer.remove();
                            this.eventReporter.sendEvent(srciEventTypeEnum);
                        }
                        srcButton = document.querySelector("srci-button");
                        if (srcButton) {
                            srcButton.remove();
                        }
                        if (!commonState.initParams) return [3 /*break*/, 2];
                        return [4 /*yield*/, initSrciImpl(commonState.initParams, SrciEventTypeEnumsObj.SDK_REINITIALIZED)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        this.getSrcProfiles = function (commonState, mastercardIdTokens, visaIdTokens, supportedNetworks) {
            if (supportedNetworks === void 0) { supportedNetworks = [DcfSdkEnumsObj.MASTERCARD, DcfSdkEnumsObj.VISA]; }
            return __awaiter(_this, void 0, void 0, function () {
                var getSrcProfiles, isMastercardIdTokens, isVisaIdTokens, mastercardGetSrcProfileParams, visaGetSrcProfileParams, mastercardResult, visaResult, hasUsableProfile, profileErrors;
                var _a, _b, _c, _d;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            getSrcProfiles = {
                                mastercardGetProfileResponse: undefined,
                                visaGetProfileResponse: undefined,
                            };
                            isMastercardIdTokens = mastercardIdTokens ? mastercardIdTokens.length > 0 : false;
                            isVisaIdTokens = visaIdTokens ? visaIdTokens.length > 0 : false;
                            if (!isMastercardIdTokens && !isVisaIdTokens)
                                return [2 /*return*/, getSrcProfiles];
                            mastercardGetSrcProfileParams = {
                                idTokens: isMastercardIdTokens ? mastercardIdTokens : visaIdTokens,
                            };
                            visaGetSrcProfileParams = {
                                idTokens: isVisaIdTokens ? visaIdTokens : mastercardIdTokens,
                            };
                            getSrcProfiles.errors = [];
                            if (!supportedNetworks.includes(DcfSdkEnumsObj.MASTERCARD)) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.getNetworkProfile(mastercardGetSrcProfileParams, DcfSdkEnumsObj.MASTERCARD)];
                        case 1:
                            mastercardResult = _e.sent();
                            getSrcProfiles.mastercardGetProfileResponse = mastercardResult.profile;
                            if (mastercardResult.error)
                                getSrcProfiles.errors.push(mastercardResult.error);
                            _e.label = 2;
                        case 2:
                            if (!supportedNetworks.includes(DcfSdkEnumsObj.VISA)) return [3 /*break*/, 4];
                            return [4 /*yield*/, this.getNetworkProfile(visaGetSrcProfileParams, DcfSdkEnumsObj.VISA)];
                        case 3:
                            visaResult = _e.sent();
                            getSrcProfiles.visaGetProfileResponse = visaResult.profile;
                            if (visaResult.error)
                                getSrcProfiles.errors.push(visaResult.error);
                            _e.label = 4;
                        case 4:
                            hasUsableProfile = Boolean((_b = (_a = getSrcProfiles.mastercardGetProfileResponse) === null || _a === void 0 ? void 0 : _a.profiles) === null || _b === void 0 ? void 0 : _b.length) ||
                                Boolean((_d = (_c = getSrcProfiles.visaGetProfileResponse) === null || _c === void 0 ? void 0 : _c.profiles) === null || _d === void 0 ? void 0 : _d.length);
                            profileErrors = getSrcProfiles.errors || [];
                            if (profileErrors.length > 0 && hasUsableProfile) {
                                getSrcProfiles.errors = profileErrors.filter(function (error) {
                                    var reason = "";
                                    if (typeof error.reason === "string")
                                        reason = error.reason;
                                    else if (typeof error.reason === "object" && typeof error.reason.reason === "string")
                                        reason = error.reason.reason;
                                    return (reason !== ErrorCodesObj.AUTH_INVALID &&
                                        reason !== SomethingWentWrongErrorCodesObj.INVALID_PARAMETER);
                                });
                                commonState.profileErrors = getSrcProfiles.errors.length > 0 ? getSrcProfiles.errors : undefined;
                            }
                            else {
                                commonState.profileErrors = profileErrors.length > 0 ? profileErrors : undefined;
                            }
                            return [2 /*return*/, getSrcProfiles];
                    }
                });
            });
        };
        this.getNetworkProfile = function (params, network) { return __awaiter(_this, void 0, void 0, function () {
            var response, reason, _a, reason;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.eventReporter.sendEvent(SrciEventTypeEnumsObj.GET_SRCI_PROFILE_STARTED, { network: network });
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, srciLogicSdk.getSrcProfile(params, network)];
                    case 2:
                        response = (_b.sent())[0];
                        if (!response) {
                            reason = SomethingWentWrongErrorCodesObj.SERVER_ERROR;
                            this.eventReporter.sendEvent(SrciEventTypeEnumsObj.GET_SRCI_PROFILE_ERROR, buildReasonTelemetry("INVALID_RESPONSE", { network: network }));
                            return [2 /*return*/, { error: { dcf: network, reason: reason } }];
                        }
                        if (response.status === ResultStatusObj.FULFILLED) {
                            if (!response.value) {
                                this.eventReporter.sendEvent(SrciEventTypeEnumsObj.GET_SRCI_PROFILE_ERROR, buildReasonTelemetry("INVALID_RESPONSE", { network: network }));
                                return [2 /*return*/, { profile: response.value }];
                            }
                            this.eventReporter.sendEvent(SrciEventTypeEnumsObj.GET_SRCI_PROFILE_SUCCESS, buildProfileSuccessTelemetry(network));
                            return [2 /*return*/, { profile: response.value }];
                        }
                        this.eventReporter.sendEvent(SrciEventTypeEnumsObj.GET_SRCI_PROFILE_ERROR, buildDcfTelemetry(response, { network: network }));
                        return [2 /*return*/, { error: { dcf: network, reason: response.reason } }];
                    case 3:
                        _a = _b.sent();
                        reason = SomethingWentWrongErrorCodesObj.SERVER_ERROR;
                        this.eventReporter.sendEvent(SrciEventTypeEnumsObj.GET_SRCI_PROFILE_ERROR, buildReasonTelemetry(reason, { network: network }));
                        return [2 /*return*/, { error: { dcf: network, reason: reason } }];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        this.callIdentityLookup = function (commonState, consumerEmail) { return __awaiter(_this, void 0, void 0, function () {
            var consumerIdentity, identityLookupParams, identityLookupResponse, errorsList, _i, identityLookupResponse_1, response;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        commonState.isConsumerPresent = false;
                        commonState.defaultDcfSdk = undefined;
                        consumerIdentity = {
                            identityProvider: "SRC",
                            identityType: "EMAIL_ADDRESS",
                            type: "EMAIL",
                            identityValue: consumerEmail,
                        };
                        identityLookupParams = {
                            consumerIdentity: consumerIdentity,
                        };
                        return [4 /*yield*/, this.identityLifecycle.identityLookup(identityLookupParams)];
                    case 1:
                        identityLookupResponse = _b.sent();
                        if (!Array.isArray(identityLookupResponse) || identityLookupResponse.length === 0) {
                            return [2 /*return*/, [{ reason: SomethingWentWrongErrorCodesObj.SERVER_ERROR }]];
                        }
                        errorsList = [];
                        for (_i = 0, identityLookupResponse_1 = identityLookupResponse; _i < identityLookupResponse_1.length; _i++) {
                            response = identityLookupResponse_1[_i];
                            if (response.status === ResultStatusObj.FULFILLED &&
                                typeof ((_a = response.value) === null || _a === void 0 ? void 0 : _a.consumerPresent) === "boolean") {
                                if (response.value.consumerPresent && !commonState.isConsumerPresent) {
                                    commonState.isConsumerPresent = true;
                                    commonState.defaultDcfSdk = response.sdk;
                                }
                            }
                            else {
                                errorsList.push({
                                    dcf: response.sdk,
                                    reason: response.status === ResultStatusObj.FULFILLED
                                        ? SomethingWentWrongErrorCodesObj.SERVER_ERROR
                                        : response.reason,
                                });
                            }
                        }
                        if (commonState.isConsumerPresent)
                            return [2 /*return*/, []];
                        if (!errorsList.length)
                            errorsList.push({ reason: ErrorCodesObj.EMPTY_PROFILE_LIST });
                        return [2 /*return*/, errorsList];
                }
            });
        }); };
        this.initiateIdentityValidation = function (validationChannelId, network, operation) { return _this.identityLifecycle.sendOtp(validationChannelId, network, operation); };
        this.completeIdentityValidation = function (otp, network) {
            return _this.identityLifecycle.validateOtp(otp, network);
        };
        this.srciDcfFrame = srciDcfFrame;
        this.languageHandler = languageHandler;
        this.eventReporter = eventReporter;
        this.allowedCardCountries = allowedCardCountries;
        this.allowedCardTypes = allowedCardTypes;
        this.merchantRecognition = merchantRecognition !== null && merchantRecognition !== void 0 ? merchantRecognition : new MerchantRecognitionCoordinator(eventReporter);
        this.identityLifecycle = new SrciIdentityLifecycle(eventReporter);
    }
    return SrciLogic;
}());
export { SrciLogic };
